const SCROLLABLE_OVERFLOW = /(auto|scroll|overlay)/;
const DEFAULT_STICKY_HEADER_OFFSET = 220;
const SCROLL_BEFORE_OFFSET = 100;

export const getScrollableParent = (element: HTMLElement | null): HTMLElement | null => {
  if (!element) return null;

  let parent = element.parentElement;

  while (parent) {
    const style = window.getComputedStyle(parent);
    const isScrollable = SCROLLABLE_OVERFLOW.test(style.overflowY) && parent.scrollHeight > parent.clientHeight;

    if (isScrollable) {
      return parent;
    }

    parent = parent.parentElement;
  }

  return null;
};

export const getStickyHeaderOffset = (): number => {
  const stickyHeader = document.querySelector('[data-testid="detail-sticky-header"]');

  if (stickyHeader instanceof HTMLElement) {
    return stickyHeader.getBoundingClientRect().height + SCROLL_BEFORE_OFFSET;
  }

  return DEFAULT_STICKY_HEADER_OFFSET;
};

export const scrollExpandedSectionIntoView = (element: HTMLElement | null): void => {
  if (!element) return;

  const offset = getStickyHeaderOffset();
  const scrollParent = getScrollableParent(element);
  const targetElement = element.querySelector<HTMLElement>('.MuiAccordionSummary-root') ?? element;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (!scrollParent) {
        const targetTop = window.scrollY + targetElement.getBoundingClientRect().top - offset;

        window.scrollTo({
          top: Math.max(targetTop, 0),
          behavior: 'smooth',
        });

        return;
      }

      const container = scrollParent;
      const elementRect = targetElement.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      const targetTop = container.scrollTop + elementRect.top - containerRect.top - offset;

      container.scrollTo({
        top: Math.max(targetTop, 0),
        behavior: 'smooth',
      });
    });
  });
};
